import { render, staticRenderFns } from "./BestBuysTablePane.vue?vue&type=template&id=01b51cc1&scoped=true"
import script from "./BestBuysTablePane.vue?vue&type=script&lang=js"
export * from "./BestBuysTablePane.vue?vue&type=script&lang=js"
import style0 from "./BestBuysTablePane.vue?vue&type=style&index=0&id=01b51cc1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b51cc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b51cc1')) {
      api.createRecord('01b51cc1', component.options)
    } else {
      api.reload('01b51cc1', component.options)
    }
    module.hot.accept("./BestBuysTablePane.vue?vue&type=template&id=01b51cc1&scoped=true", function () {
      api.rerender('01b51cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/best_buys/BestBuysTablePane.vue"
export default component.exports